import { render, staticRenderFns } from "./CatalogImportMethods.vue?vue&type=template&id=33e897f2"
import script from "./CatalogImportMethods.vue?vue&type=script&lang=js"
export * from "./CatalogImportMethods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports